var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-container",style:({
    width: _vm.width,
    height: _vm.height,
  })},[_c('div',{staticClass:"background",style:({'backgroundImage': ("url(" + _vm.src)})}),_vm._v(" "),_c('div',{staticClass:"foreground",style:({'backgroundImage': ("url(" + _vm.src)})})])}
var staticRenderFns = []

export { render, staticRenderFns }